"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeaderStyle1 = void 0;
var react_1 = __importDefault(require("react"));
var Buttons_1 = require("../../../../Buttons");
var OKELink_1 = require("../../../../OKELink");
var Typo_1 = require("../../../../Typo");
var styled_1 = require("../../styled");
var ModalHeaderStyle1 = function (_a) {
    var title = _a.title, linkTo = _a.linkTo, onClose = _a.onClose, setAnimPos = _a.setAnimPos, initAnimPos = _a.initAnimPos, invert = _a.invert, _b = _a.dynamicHeaderHeight, dynamicHeaderHeight = _b === void 0 ? false : _b;
    return (react_1.default.createElement(styled_1.StyledModalLargeHeader, { invert: invert, dynamicHeaderHeight: dynamicHeaderHeight },
        react_1.default.createElement("div", { style: {
                display: "flex",
                gap: "2.5rem",
                alignItems: "center",
            } },
            !linkTo && title && (react_1.default.createElement("div", null,
                react_1.default.createElement(Typo_1.SANS_3, { invert: invert, semibold: true }, title))),
            linkTo && (react_1.default.createElement(Typo_1.SANS_4, { semibold: true },
                react_1.default.createElement(OKELink_1.OKELink, { iconAfter: "ArrowLineUpRight", linkType: "action", onClick: function () { return window.open(linkTo); }, iconSize: 15, color: "black", invert: invert }, title)))),
        onClose && (react_1.default.createElement(Buttons_1.ButtonGhost, { invert: invert, icon: "X", onClick: function () { return setAnimPos(initAnimPos); } }))));
};
exports.ModalHeaderStyle1 = ModalHeaderStyle1;
